export type SearchableValue = string | number | null | undefined

export const normalizeSearchText = (value: SearchableValue): string =>
  String(value ?? '')
    .normalize('NFKC')
    .toLocaleLowerCase('ja-JP')
    .trim()

export const matchesSearch = (
  values: SearchableValue[],
  query: string,
): boolean => {
  const normalizedQuery = normalizeSearchText(query)

  if (!normalizedQuery) {
    return true
  }

  return values.some((value) =>
    normalizeSearchText(value).includes(normalizedQuery),
  )
}
